import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import {
  EXCLUDE_OPTION,
  FormFields,
} from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { InsuranceData } from '../../../useInsurance';
import { InsuranceType, LifeInsurancePolicyTypeEnum } from '../../../api/useInsuranceQuery';

interface Props {
  data: InsuranceData;
}

export const AssetBucketing = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  const {
    Options: { AllowAssetBucketingCustomization, AvailableAssetBuckets, DefaultAssetBucketIndex },
    accountOptions: { AssetBucketingByManagementStyle, ManagementStyles, DisplayAssetBucketing },
  } = data;

  const [
    orionManagementStyleId,
    customAssetBucketIndex,
    insuranceType,
    policyType,
  ] = formBag.watch([
    'OrionManagementStyleId',
    'CustomAssetBucketIndex',
    'InsuranceType',
    'LifeInsurancePolicyType',
  ]);

  if (
    !DisplayAssetBucketing ||
    (!AssetBucketingByManagementStyle && policyType !== LifeInsurancePolicyTypeEnum.Permanent) ||
    (insuranceType !== InsuranceType.Life && !AssetBucketingByManagementStyle)
  ) {
    return null;
  }

  const isDisabled =
    (AssetBucketingByManagementStyle && orionManagementStyleId === null) ||
    !AllowAssetBucketingCustomization;

  const assetBucketOptions = AvailableAssetBuckets.map(({ Title }, index) => ({
    label: Title,
    value: index,
  }));

  const options = [...assetBucketOptions, EXCLUDE_OPTION].map(option => {
    if (AssetBucketingByManagementStyle) {
      const isDefault =
        ManagementStyles.find(style => style.id === orionManagementStyleId)?.defaultBucket ??
        EXCLUDE_OPTION.value;

      return {
        ...option,
        rightLabel: option.value === isDefault ? 'Default' : undefined,
      };
    }

    if (customAssetBucketIndex !== null) {
      return {
        ...option,
        rightLabel: option.value === customAssetBucketIndex ? 'Default' : undefined,
      };
    }

    return {
      ...option,
      rightLabel: option.value === DefaultAssetBucketIndex ? 'Default' : undefined,
    };
  });

  return (
    <Controller
      control={formBag.control}
      name="CustomAssetBucketIndex"
      render={({ field: { value, onChange, disabled } }) => {
        return (
          <Select
            value={options.find(opt => opt.value === value)}
            options={options}
            onChange={opt => onChange(opt?.value)}
            label="Asset Bucketing"
            placeholder={isDisabled ? 'Select Management Style' : 'Select Asset Bucketing'}
            disabled={disabled || isDisabled}
            isPortal
          />
        );
      }}
    />
  );
};
